import { useBadges } from "api/badges";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { CampaignConditionNewFormat } from "types/campaigns";

interface Props {
  fieldKey: string;
  ruleData: CampaignConditionNewFormat;
}

export const BadgeParam = ({ fieldKey, ruleData }: Props) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { message } = useMessage();
  const { useBadgesList, useBadgeDetails } = useBadges();
  const { data: initialValue } = useBadgeDetails(
    ruleData.value.params?.badgeTypeId,
  );
  const { data: badgeList } = useBadgesList({
    filters: searchQuery
      ? [
          {
            condition: "like",
            query: "name",
            value: searchQuery,
          },
        ]
      : [],
    order: "asc",
    sortKey: "name",
  });

  return (
    <SelectInput
      displaySearch
      data-test-id="badges"
      items={
        badgeList?.items.map((badge) => ({
          label: badge.name,
          id: badge.badgeTypeId,
        })) || []
      }
      label={<RequiredFieldLabel text={message({ id: "badgeName" })} />}
      name={`${fieldKey}.value.params.badgeTypeId`}
      asyncSearch={(searchedQuery) => setSearchQuery(searchedQuery)}
      initialValue={
        initialValue && {
          label: initialValue.name,
          id: initialValue.badgeTypeId,
        }
      }
    />
  );
};
